/**
 * Reads a free-text search term out of a TanStack Router search param.
 *
 * TanStack's default parser runs every search value through `JSON.parse` and
 * keeps the result when it succeeds, so a URL the user reads as text does not
 * arrive as text: `?search=12345` is a number, `?search=true` a boolean,
 * `?search=null` null, `?search={"a":1}` an object. A plain
 * `typeof value === 'string'` guard therefore drops perfectly good searches —
 * notably reference numbers, which could be supplied.
 *
 * Primitives are converted back to the text the user typed; structured values
 * (objects, arrays, null) are dropped, since no search box produces them.
 */
export function parseSearchTermParam(value) {
    if (typeof value === 'string')
        return value || undefined;
    if (typeof value === 'number' && Number.isFinite(value))
        return String(value);
    if (typeof value === 'boolean')
        return String(value);
    return undefined;
}
//# sourceMappingURL=parseSearchTermParam.js.map